import { render, staticRenderFns } from "./ScreenAutomationsLog.vue?vue&type=template&id=02810c6a&scoped=true&"
import script from "./ScreenAutomationsLog.vue?vue&type=script&lang=js&"
export * from "./ScreenAutomationsLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02810c6a",
  null
  
)

export default component.exports